import { IHttpWrap } from '../service'
import { IAccountErrorResponse, IErrorResponse } from '../service/http/types'
import { showSingleToast } from './toast'

// https://github.com/Tencent/wujie/issues/434
export const wujieCommonPlugins = [
  {
    patchElementHook(element: any, iframeWindow: any) {
      if (element.nodeName === 'STYLE') {
        element.insertAdjacentElement = function (_position: any, ele: any) {
          iframeWindow.document.head.appendChild(ele)
        }
      }
    },
  },
]

export async function synapseApi2WujieAxiosAdapter<T>(result: IHttpWrap<T, IErrorResponse | IAccountErrorResponse>) {
  if (result.success) {
    return result
  }
  return Promise.reject({
    status: result.status,
    response: {
      data: result.data,
    },
  })
}

export const wujieInfrastructure = {
  showToast: showSingleToast,
}
